import { render, staticRenderFns } from "./firmOrder.vue?vue&type=template&id=96fe8816&scoped=true&"
import script from "./firmOrder.vue?vue&type=script&lang=js&"
export * from "./firmOrder.vue?vue&type=script&lang=js&"
import style0 from "./firmOrder.vue?vue&type=style&index=0&id=96fe8816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe8816",
  null
  
)

export default component.exports